import React, { memo } from 'react';
import { styled } from 'linaria/react';
import { ContentTitle } from './ContentTitle';
import MaxWidth from '../../Layout/MaxWidth';

const OuterWrapper = styled(MaxWidth)`
  padding: 0 0 0 10px;
`;

const ImageLinksRowWrapper = styled('div')`
  display: flex;
  width: fit-content;
  max-width: 100%;
  margin: 0 auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE10+ */
  gap: 10px;
  scroll-snap-type: x mandatory;

  &::-webkit-scrollbar {
    display: none;
  }

  .image-links-row-item {
    margin: 0;
    scroll-snap-align: start;

    .image-wrapper {
      border-radius: 10px;
    }
  }
`;

export const StartPageImageLinksRow = memo(
  ({ title, titleColor, children }) => {
    return (
      <OuterWrapper>
        {title?.value && (
          <ContentTitle
            text={title?.value}
            style={{ color: titleColor?.value ?? '#000' }}
          />
        )}
        <ImageLinksRowWrapper>{children}</ImageLinksRowWrapper>
      </OuterWrapper>
    );
  }
);
